import m from "mithril";
import MessageProvider from "../../../MessageProvider";
import { Location } from "../../../Models";
import BookingSearchCriteria from "../../../states/BookingSearchCriteria";
import BookingSearchFormState, { BookingLookupResultState } from "../../../states/BookingSearchFormState";
import SearchBookingFormComponent from "./SearchBookingFormComponent";

interface Attrs { 
    locations : Location[],
    messageProvider: MessageProvider;
    bookingSearchFormState: BookingSearchFormState;
    bookingLookupResultState: BookingLookupResultState;
    isMobile?: boolean;
    onSearch: (searchCriteria:BookingSearchCriteria) => void;
    onLocationClick: () => void;
    onDateRangePickerClick: () => void;
}

function BookingSearchFormCard(): m.Component<Attrs> {
    return {
        view(vnode) {    
            const {messageProvider, bookingLookupResultState, bookingSearchFormState, isMobile, onSearch, onLocationClick, onDateRangePickerClick} = vnode.attrs;    
    
            return m("div",{}, [                
                m("div.card shadow-lg rounded-25", 
                    m("div.card-body", { class: (isMobile)? "": " pb-0" }, [
                        m(SearchBookingFormComponent, {                
                            messageProvider : messageProvider,
                            bookingSearchFormState : bookingSearchFormState,
                            bookingLookupResultState : bookingLookupResultState,
                            isOnDesktop: true,
                            isOpeningDialog: false,
                            onSearchClick: function(){
                                onSearch(bookingSearchFormState.toBookingSearchCriteria());
                            },
                            onLocationClick: function() {                                
                                onLocationClick();
                            },
                            onDateRangePickerClick: function(){
                                onDateRangePickerClick();
                            },
                            onEmailOrPhoneChange: function(emailOrPhone: string){
                                bookingSearchFormState.emailOrPhone = emailOrPhone;
                            }
                        })
                    ])
                )  
            ])
        }
    }
}

export default BookingSearchFormCard;

